var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videoList.length)?_c('div',_vm._l((_vm.videoList),function(video){return _c('VideoListItem',{key:video.id.videoId,attrs:{"video":video},on:{"on-select-video":_vm.onSelectVideo}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }